import React from 'react';
import { Container } from '../style';
import { useTranslation } from 'react-i18next';



const MoneyCredit = () => {
  const { t } = useTranslation();

    return (
        <Container>
         <main class="main">
         <section className="strategy">
      <div className="strategy__container">
        <h2 className="strategy__title">{t('strategy.title')}</h2>
        <ul className="strategy__list">
          {t('strategy.list', { returnObjects: true }).map((item, index) => (
            <li className="strategy__item" key={index}>
              <h3 className="strategy__item-title">{item.itemTitle}</h3>
              <p className="strategy__item-text">{item.itemText}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>


    <section class="section">
            <div class="section__container">
             
                <p class="section__text">
                    <a style={{color:"#000"} } target="_blank" href={t('strategy.file-link')}>
                    {t('strategy.file-title')}</a>
                </p>
            </div>
        </section>

    
  </main>
        </Container>
    );
}

export default MoneyCredit;
